<template>
  <v-row v-if="!!order">
    <v-col
      cols="6"
      md="4"
    >
      <v-card-title>Cliente</v-card-title>
      <v-card-text>
        <div class="my-2 subtitle-1">
          Orden #{{ order.orderNumber }}
        </div>
        <div class="my-2 subtitle-1">
          {{ order.customerName }}
        </div>
        <div class="my-2 subtitle-1">
          Ced: {{ order.customerNip }}
        </div>
        <div class="my-2 subtitle-1">
          Tel: {{ order.customerPhoneNumber }}
        </div>
        <!-- <div>
              Small plates, salads & sandwiches - an intimate setting with 12
              indoor seats plus patio seating.
            </div> -->
      </v-card-text>
      <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          /> -->
    </v-col>
    <v-col
      cols="6"
      md="4"
    >
      <v-card-title>Envío</v-card-title>
      <v-card-text>
        <div class="my-2 subtitle-1">
          {{ order.shippingMethodDetail }} ${{ order.shippingCost }}
        </div>
        <div class="my-1 subtitle-1">
          {{ order.shippingAddressCity }}
        </div>
        <div class="my-1 subtitle-1">
          {{ order.shippingAddressLine }}
        </div>
        <div class="my-1 subtitle-1">
          {{ order.shippingAddressDetail }}
        </div>
        <div class="my-1 subtitle-1">
          {{ order.shippingAddressCode }}
        </div>
      </v-card-text>
      <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          /> -->
    </v-col>
    <v-col
      cols="6"
      md="4"
    >
      <v-card-title>Pago</v-card-title>
      <v-card-text>
        <div class="mt-2 subtitle-1">
          {{ order.paymentDetail }}
        </div>
        <div
          v-if="!!order.paymentMethod && order.paymentMethod.code == 'visa'"
          class="mt-0 subtitle-1"
        >
          xxxx-xxxx-xxxx-{{ order.creditCardTerminationNumber }}
        </div>
        <div v-if="!!order.paymentMethod && order.paymentMethod.code == 'transfer'">
          <a
            v-if="get_url_extension(order.imageUrl) === 'pdf'"
            class=""
            :href="order.imageUrl"
            target="_blank"
          ><span asp-loc>COMPROBANTE</span></a>
          <v-btn
            v-else
            color="success"
            class="px-1 ml-1 d-flex d-sm-none"
            fab
            x-small
          >
            <v-icon

              @click="showDialog(order.imageUrl)"
            >
              mdi-file-image
            </v-icon>
          </v-btn>
          <v-img
            class="d-none d-sm-flex"
            :lazy-src="order.imageUrl"
            max-height="100%"
            max-width="50px"
            :src="order.imageUrl"
            @click="showDialog(order.imageUrl)"
          />
        </div>
        <div class="mt-3 subtitle-3">
          Sub Total: ${{ order.subTotal }} ivai
        </div>
        <div class="my-2 subtitle-3">
          Envío: ${{ order.shippingCost }}
        </div>
        <div class="my-2 subtitle-3">
          Descuento: ${{ order.discount }}
        </div>
        <v-divider class="mt-3" />
        <div class="my-2 subtitle-3">
          Total: ${{ order.totalWithShipping }}
        </div>
      </v-card-text>
      <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          /> -->
    </v-col>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="600"
        >
          <v-card>
            <v-img
              :lazy-src="dialogImage"
              :src="dialogImage"
              @click="dialog = false"
            />
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-row>
</template>

<script>
  export default {
    name: 'OrderSummary',

    props: {
      order: {
        type: Object,
        default: () => ({}),
      },
    },
    data: () => ({
      dialog: false,
      dialogImage: '',
    }),
    methods: {
      get_url_extension (url) {
        return url ? url.split(/[#?]/)[0].split('.').pop().trim() : ''
      },
      showDialog (url) {
        this.dialog = true
        this.dialogImage = url
      },
    },
  }
</script>
